import { cva } from '@/styled-system/css';

export const upsellLegalRecipe = cva({
  base: {
    'marginBlockStart': 'Upsell.Legal.margin.content-toActions',

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'fineprint',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'Upsell.Legal.neutral.text-legal',
      },
      soft: {
        color: 'Upsell.Legal.soft.text-legal',
      },
      hero: {
        color: 'Upsell.Legal.hero.text-legal',
      },
      impact: {
        color: 'Upsell.Legal.impact.text-legal',
      },
    },
  },
});
